function changeVariants($this) {
  const $form = $this.closest('form');
  const $select = $form.find('.js-select-global');
  const almostGone = $select.data('almost-gone-number');
  const $product = $this.closest('.js-product');
  const backOrderHtml = $form.data('form-back');
  const $btnDetails = $product.find('.js-product-details');
  let indexValue = $form.find('.js-form-row').length;
  let optionString;
  let values = [];

  $form.find('.js-form-row').each(function() {
    const $row = $(this);
    let elemVal;

    if ($row.find('.js-radio-color').length) {
      elemVal = $row.find('[data-value]:checked').data('value');
    } else {
      elemVal = $row.find('[data-value]:selected').data('value');
    }

    if ($row.find('.js-form-label span').length) {
      $row.find('.js-form-label span').text(elemVal);
    }

    values.push(elemVal);
  });

  if (values.length == 1) {
    optionString = `[data-option-1="${values[0]}"]`;
  } else if (values.length == 2) {
    optionString = `[data-option-1="${values[0]}"][data-option-2="${values[1]}"]`;
  } else {
    optionString = `[data-option-1="${values[0]}"][data-option-2="${values[1]}"][data-option-3="${values[2]}"]`;
  }

  $select.find(`option${optionString}`).prop('selected', 'selected');

  // New Selected Option
  const $optionSelected = $select.find('option:selected');
  const price = $optionSelected.data('price');
  const inventory = $optionSelected.data('inventory');

  if ($form.find('.form-product__input-back').length) {
    $form.find('.form-product__input-back').remove();
  }

  // Sold Out
  if ($optionSelected.is(':disabled')) {
    $product.addClass('section-product--sold-out');

    $form
      .addClass('form-product--sold-out')
      .removeClass('form-product--pre-order')
      .find('.js-product-btn')
      .attr('disabled', 'disabled');
  } else {
    $product.removeClass('section-product--sold-out');

    $form
      .removeClass('form-product--sold-out')
      .find('.js-product-btn')
      .removeAttr('disabled');

    if (inventory == 0) {
      $form.addClass('form-product--pre-order');

      if (backOrderHtml != '') {
        $(backOrderHtml).prependTo($form);
      }
    } else {
      $form.removeClass('form-product--pre-order');
    }
  }

  // Price
  if ($product.find('.js-product-price').length) {
    $product.find('.js-product-price').html(price);
  }

  // Inventory
  if ($form.find('.js-product-message').length) {
    $form
      .find('.js-product-message')
      .addClass('hidden')
      .find('small')
      .text(inventory);
  }

  if (almostGone != '') {
    if (almostGone >= inventory && inventory > 0) {
      $product.find('.section__badge--almost').removeClass('hidden');
    } else {
      $product.find('.section__badge--almost').addClass('hidden');
    }
  }

  if ($btnDetails.length) {
    const btnDetailsHref = $btnDetails.attr('href');
    let btnDetailsNewHref = '';
    if (btnDetailsHref.indexOf('?variant=') !== -1) {
      btnDetailsNewHref = btnDetailsHref.split('?variant=')[0];
    } else {
      btnDetailsNewHref = btnDetailsHref;
    }

    $btnDetails.attr('href', `${btnDetailsNewHref}?variant=${$select.find('option:selected').val()}`);
  }

  // Add to URL
  if ($product.hasClass('section-product--primary')) {
    window.history.replaceState(null, null, `?variant=${$select.find('option:selected').val()}`);
  }
}

module.exports = {
  changeVariants
};



// WEBPACK FOOTER //
// ../assets/js/change-variants.js